import React from 'react';

import cl from './DigitalAssetsBanking.module.css'
import digialAssetsImg from '../../../assets/images/digitalAssetsImg.png'
import fortressMacImg from '../../../assets/images/fortressMac.png'

import CustomDropDownPersonal from '../../../components/ui/CustomDropDownPersonal/CustomDropDownPersonal';
import { NavLink } from 'react-router-dom';


const DigitalAssetsBanking = () => {
    return (
        <>
            <div className={cl.digital_assets_main}>
                <div className={cl.digital_assets_container}>
                    <h2 className={cl.digital_assets_title}>
                        Digital Assets Banking
                    </h2>
                    <NavLink to='/sign-up' className={cl.sugn_ip_a}>
                        <div className={cl.open_account_white}>
                            Open Account
                        </div>
                    </NavLink>
                    <div className={cl.digital_img_wrapper}>
                        <img src={digialAssetsImg} alt="" />
                    </div>
                </div>
                <div className={cl.regulated_digital_assets_container}>
                    <h2 className={cl.regulated_digital_assets_title}>
                        Regulated Digital Assets Banking Services
                    </h2>
                    <CustomDropDownPersonal />
                </div>
                <div className={cl.expirience_container}>
                    <h2 className={cl.expirience_title}>
                        Experience Regulated Crypto Banking
                    </h2>
                    <div className={cl.expirience_descr_wrapper}>
                        <p className={cl.expirience_descr}>
                            Open your account online or schedule an appointment with our International Digital Assets Banking team.
                        </p>
                    </div>
                    <div className={cl.btn_open_wrapper}>
                        <NavLink to='/sign-up'>
                            <div className={cl.open_btn_blue}>
                                Open Account
                            </div>
                        </NavLink>                    </div>
                    <div className={cl.img_expirience_wrapper}>
                        <img src={fortressMacImg} alt="" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default DigitalAssetsBanking;